import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"
import useSortData from './useSortData';

export default function useAttributes(props, emit, attributeData) {

    // Get toast interface
    const toast = useToast()

    const search = ref("")
    const categoryId = ref("")
    const perPage = ref(10)
    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getAttributes = (url = null) => {
        store.dispatch("getAttributes", {
            url,
            search: search.value,
            categoryId: categoryId.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const onSubmit = () => {
        loading.value = true
        if (attributeData.value.id) {
            store.dispatch('updateAttribute', attributeData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("ویژگی مورد نظر با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getAttributes")
                        closeModal()
                    }
                })

        } else {
            store
                .dispatch("createAttribute", attributeData.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        toast.success(" ویژگی مورد نظر با موفقیت افزوده شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getAttributes")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }
    }


    const closeModal = () => {
        show.value = false
        errors.value = {}
        emit("close")
    }

    const { sortField, sortDirection, sortData } = useSortData(getAttributes);

    const sortAttributes = (field) => {
        sortData(field);
        getAttributes();
    };


    return {
        show,
        search,
        categoryId,
        perPage,
        sortField,
        sortDirection,
        loading,
        errors,
        getAttributes,
        onSubmit,
        closeModal,
        sortAttributes
    }
}